import { Ordering } from '@wix/comments-ooi-client/controller';
import { isQuestion } from '@wix/communities-forum-client-commons';
import { CommentsOrdering } from '../types';

export const CommentsOrderingMap = {
  latest_first: Ordering.NEWEST_FIRST,
  oldest_first: Ordering.OLDEST_FIRST,
  most_votes_first: Ordering.MOST_VOTES_FIRST,
  least_votes_first: Ordering.LEAST_VOTES_FIRST,
  most_reactions_first: Ordering.MOST_REACTIONS_FIRST,
};

const getConfig = (ordering: Ordering) => ({
  replyShowMoreLimit: 8,
  ordering,
  initialPage: {
    commentLimit: 100,
    replyLimit: 3,
  },
  pagination: {
    commentLimit: 100,
    replyLimit: 3,
  },
  maxPagesBeforeDrop: {
    commentPages: 2,
    replyPages: 4,
  },
});

export const getPaginationConfig = (post: any, commentsOrdering: CommentsOrdering) => {
  return {
    ...(isQuestion(post?.postType)
      ? getConfig(Ordering.MOST_VOTES_FIRST)
      : getConfig(Ordering.NEWEST_FIRST)),
    ...(commentsOrdering ? { ordering: CommentsOrderingMap[commentsOrdering] } : {}),
  };
};
